import firestore from "../firebase/firestore";
// import api from '../utils/api'

export const getBillingCommunications = (billing_id) => {
  return firestore
    .collection("communication")
    .where("billing_id", "==", billing_id)
    .orderBy("created_at", "asc")
    .get();
};
